var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._g({class:( _obj = {}, _obj[_vm.$style['button']] = true, _obj[_vm.$style['button_active']] = _vm.active, _obj[_vm.$style['button_inverted']] = _vm.inverted, _obj )},_vm.$listeners),[_c('SvgSpriteMore')],1)}
var staticRenderFns = []

export { render, staticRenderFns }